import { createSlice } from '@reduxjs/toolkit';
import {RootState} from "../store";

interface DataState {
    fullHeightStatus: any;
}
const initialState: DataState = {
    fullHeightStatus: false
}
const fullHeightStatus = createSlice({
    name: 'fullHeightStatus',
    initialState,
    reducers: {
        setFullHeightStatus(state, action) {
            state.fullHeightStatus = action.payload;
        },
    },
});
export const { setFullHeightStatus } = fullHeightStatus.actions;
export default fullHeightStatus.reducer;

export const dataReady = (state: RootState) => state.fullHeightStatus;
